import { SVGProps } from 'react';

export const ArrowRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg data-icon width="20" height="20" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.02 5.03986C10.18 4.66653 10.3466 4.32653 10.52 4.01986C10.6933 3.7132 10.8733 3.43986 11.06 3.19986H-3.88622e-05V1.83986H11.06C10.8733 1.59986 10.6933 1.32653 10.52 1.01986C10.3466 0.699863 10.18 0.359863 10.02 -0.00013721H11.24C12.0666 0.973196 12.96 1.69986 13.92 2.17986V2.85986C12.9733 3.32653 12.08 4.0532 11.24 5.03986H10.02Z"
      fill="currentColor"
    />
  </svg>
);
